import styled from 'styled-components';

import { colorScheme } from '../../theme';
import { grey } from '../../theme/colors';

export const PillCounter = styled.span`
  height: 24px;
  min-width: 24px;
  padding: 0 6px;
  border-radius: 12px;
  background: ${colorScheme.badge.background};
  color: ${grey.haydenGreyShade2};
  border: 1px solid ${colorScheme.primaryBorder};
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
